module.exports = __webpack_public_path__ + "img/faro-rest-2.97b22c96.jpg";